import React, { useEffect, useState } from "react";
import { Space } from "antd";

import TableCustom from "src/components/Table/CustomTable";
import ButtonCircle from "src/components/MyButton/ButtonCircle";
import CB1 from "src/components/Modal/CB1";

// Cột hàng bán trả lại
const column = [
    {
        title: "TT",
        dataIndex: "index",
        key: "index",
        render: (_, record, i) => {
            return <>{i + 1}</>;
        },
    },
    {
        title: "Số phiếu trả lại",
        dataIndex: "returnNumber",
        key: "returnNumber",
    },
    {
        title: "Tên khách hàng",
        dataIndex: "customerName",
        key: "customerName",
    },
    {
        title: "Ngày trả lại",
        dataIndex: "returnDate",
        key: "returnDate",
    },
    {
        title: "Tổng tiền",
        dataIndex: "totalAmount",
        key: "totalAmount",
    },
    {
        title: "Lý do trả lại",
        dataIndex: "reason",
        key: "reason",
    },
];

const _dataSource = [
    {
        key: 1,
        returnNumber: "R001",
        customerName: "Nguyễn Văn A",
        returnDate: "2024-08-01",
        totalAmount: 5000000,
        reason: "Hàng bị lỗi",
    },
    {
        key: 2,
        returnNumber: "R002",
        customerName: "Trần Thị B",
        returnDate: "2024-08-02",
        totalAmount: 10000000,
        reason: "Không đúng mẫu mã",
    },
    {
        key: 3,
        returnNumber: "R003",
        customerName: "Lê Văn C",
        returnDate: "2024-08-03",
        totalAmount: 7500000,
        reason: "Khách không hài lòng",
    },
];

function SalesReturnsComponent(props) {
    const [dataSource, setDataSource] = useState(_dataSource);
    const [dataSelected, setDataSelected] = useState([]);

    useEffect(() => {
        // Effect logic here if needed
    }, []);

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setDataSelected(selectedRows);
        },
    };

    return (
        <div>
            {!!dataSelected.length && (
                <ButtonCircle
                    style={{ marginRight: '10px', marginBottom: '10px' }}
                    title="Xóa hàng đã chọn"
                    iconName="delete-outline"
                    onClick={() => CB1({
                        title: `Bạn có chắc chắn muốn xoá <strong>${dataSelected.length}</strong> bản ghi không?`,
                        icon: "trashRed",
                        okText: "Đồng ý",
                        onOk: async close => {
                            // Logic to delete selected rows
                            close();
                        },
                    })}
                />
            )}
            <TableCustom
                isPrimary
                columns={column}
                dataSource={dataSource}
                showPagination
                rowSelection={{
                    type: "checkbox",
                    ...rowSelection,
                }}
                footerLeft={<div className="d-flex mt-20" />}
                widthScroll={1200}
                textEmpty="Không có dữ liệu!"
            />
        </div>
    );
}

export default SalesReturnsComponent;
